import { RichTextToolbarButton } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';
import { getActiveFormats, registerFormatType, toggleFormat } from '@wordpress/rich-text';

/*
	Register underline button to rich text editor
	https://developer.wordpress.org/block-editor/how-to-guides/format-api/
*/
if(!getActiveFormats('<u></u>','create-block/underline').includes('create-block/underline')){
  registerFormatType('create-block/underline', {
    title: __('underline'),
    tagName: 'u',
    className: null,
    edit: ({ isActive, onChange, value }) => {
      return (
        <RichTextToolbarButton
          icon="editor-underline"
          title={__('underline')}
          onClick={() => {
            onChange(
              toggleFormat(value, {
                type: 'create-block/underline'
              })
            );
          }}
          isActive={isActive}
        />
      );
    }
  });
}
